module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-labels-angled-d4270070b46ff3b294e8912d95ffb15d.svg";